angular.module('impactx.MenuDirectives').controller('BasketMenuCtrl', ['$scope', '$context', 'TranslationService', '$redirect',
    'ToastService', '$location', '$securityManager', 'RFQSearchService', 'dataGen', BasketMenuCtrl]);
function BasketMenuCtrl($scope, $context, TranslationService, $redirect, ToastService, $location, $securityManager, RFQSearchService, dataGen)
{
    this.context = $context;
    $scope.$watch(function () { return $context.showBasket.value }, function (newVal) {
        $scope.showBasket = newVal;
        $scope.trns = {};
        $scope.trns.openBasket = TranslationService.get('openBasket');
    });
    $scope.$watch(function () { return $context.showSupplierBasket.value }, function (newVal) {
        $scope.showSupplierBasket = newVal;
        $scope.trns = {};
        $scope.trns.openBasket = TranslationService.get('openSupplierBasket');
    });
    $scope.$watch(function () { return $context.basketIsDisposition }, function (newVal) {
        $scope.basketIsDisposition = newVal;
        $scope.trns = {};
        $scope.trns.openBasket = TranslationService.get('openDisposition');
    });
    $scope.$watch(function() {
        return $context.hasRFQSSearch.value
    }, function(newValue) {
        $scope.showRFQSBasket = newValue;
        $scope.trns.openBasket = TranslationService.get('deactivateRFQS');
    });

    this.redirectToBasket = function () {
        if ($scope.showRFQSBasket) {
            RFQSearchService.deactivateRFQSSearchAndRedirect(true);
        }
        else if ($scope.showBasket) {
            $redirect.redirectTo(null, "/basket");
        }
        else if ($scope.showSupplierBasket) {
            var link = $context.hasSupplierBasket.value ? ("/supplierbasket/" + $context.hasSupplierBasket.id) : "/supplierbaskettemplatelist";
            $redirect.redirectTo(null, link);
        }
    }
}